var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-credits-list-item-img-item"},[_c('asset',{attrs:{"asset":_vm.asset}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }